import { FC } from "react"
import { SidebarListItemProps } from "../types"

export const SideBarListItems : FC<SidebarListItemProps> = (props) => {
    return (
        <ul className="space-y-2 group-hover:text-gray-900">
            {props.children}
        </ul>
    )
}